// Func = limiting Scope for this file
var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

	if(!(window.ActiveXObject) && "ActiveXObject" in window) {

		/*is explorer*/
		function msieversion() {
			let ua = window.navigator.userAgent;
			let msie = ua.indexOf("MSIE ");
			if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))
			{
				const image_fit = document.getElementsByClassName('image-fit__wrapper');
				for(let i = 0; i < image_fit.length; i++ ){
					const this_image = image_fit[i].getElementsByTagName('img')[0];
					const image_data = this_image.dataset.srcset;
					const image_src = this_image.getAttribute('src');
					image_fit[i].classList.add('ie-bg');
					if(image_data){
						image_fit[i].style.backgroundImage = 'url("'+image_data+'")';
					}else{
						image_fit[i].style.backgroundImage = 'url("'+image_src+'")';
					}

				}
			}
			else
			{
				console.log('other browser');
			}
			return false;
		}
		msieversion();

	} else {
		/*****************************************************
		 OBSERVER TO ADD PARALLAX EFFECT
		 *****************************************************/
		let scrollParallax = []
		let scrolled = 0

		/* screen height */
		let v_height = window.innerHeight
			|| document.documentElement.clientHeight
			|| document.body.clientHeight;

		function doParallax(elm) {

			let boundes = elm.dataset.parallax.split(",") /* get it from html */
			/*get distance in positive value*/
			let distance = Math.abs(boundes[0] - boundes[1])
			if (boundes[0] > boundes[1]) {
				/*get distance in negative value (to do the scroll inverse)*/
				distance = distance * -1
			}
			/*Equivalent distance using screen height + element height*/
			const unit_scroll = distance / (v_height + elm.offsetHeight)
			let temp = 0

			let topElement = 0;
			let element = elm;

			let id_elem = elm.dataset.parallaxid

			do {
				topElement += element.offsetTop || 0;
				element = element.offsetParent;
			} while (element)

			let parallaxFunction = function () {
				/*Obtain the distance between top screen and document top 0*/
				scrolled = document.documentElement.scrollTop || window.pageYOffset
				/*Distance of bottom page to top of the element*/
				let relative_distance = scrolled + v_height - topElement
				/*transpoling data to move the parallax element relative to the scroll of all the screen*/
				temp = (unit_scroll * relative_distance) + parseInt(boundes[0])
				/*console.log('scroll: '+scrolled+' v_height: '+v_height+' element top: '+elm.offsetTop)*/
				elm.setAttribute('style', 'transform: translate(0, ' + temp + 'px)')
			}

			scrollParallax[id_elem] = parallaxFunction

			window.addEventListener('scroll', scrollParallax[id_elem])

		}

		let observers_parallax = document.querySelectorAll(".js-parallax-element")

		if (observers_parallax) {
			let options_parallax = {
				root: null, /* relative to document viewport */
				rootMargin: '0px', /* margin around root. Values are similar to css property. Unitless values not allowed */
				threshold: 0 /* visible amount of item shown in relation to root */
			}

			function handler_parallax(entries, observer) {
				let entry;
				entries.forEach(function (entry) {
					if (entry.isIntersecting) {
						doParallax(entry.target)
					} else {
						let id_elem = entry.target.dataset.parallaxid
						window.removeEventListener('scroll', scrollParallax[id_elem])
					}
				})
			}

			let observable_parallax = new IntersectionObserver(handler_parallax, options_parallax)
			let counter = 1
			observers_parallax.forEach(function (element) {
				observable_parallax.observe(element)
				element.dataset.parallaxid = counter
				counter++
			})
		}
		/********************************************************************************
		 END OF OBSERVER TO ADD PARALLAX EFFECT
		 ***********************************************************************************/
	}

	/* Text and Form Animations */
	let formModule = document.querySelectorAll('.form-module-wrapper form');
	let textModule = document.querySelectorAll('.text-modules-wrapper .text-modules');
	if(formModule){
		formModule.forEach(function(form_module) {
			form_module.classList.add('animate-fade', 'top');
		});
	}
	if(textModule){
		textModule.forEach(function(text_module) {
			text_module.classList.add('animate-fade', 'top');
		});
	}

	document.addEventListener('DOMContentLoaded', () => {

		// Main Nav Dropdown
		let primaryNav = document.getElementById('primary-nav');
		if(primaryNav){
			primaryNav.querySelectorAll('li').forEach(function(primary_nav) {
				const linksNav = document.querySelectorAll('.inner #primary-nav a , #secondary-footer li a');
				let link = primary_nav.querySelector('a');
				let subMenu = primary_nav.querySelector('ul.submenu');
				let timeout;
				linksNav.forEach(link => {
					link.setAttribute('tabindex', '-1');
				});

				if (link) {
					link.setAttribute('tabindex', '0');
				}
				primary_nav.addEventListener("mouseover", (event) => {
					clearTimeout(timeout);
					primary_nav.classList.add('hover');
					if(subMenu){
						subMenu.classList.add('open');
					}
				});
				primary_nav.addEventListener("mouseout", (event) => {
					timeout = setTimeout(() => {
						primary_nav.classList.remove('hover');
						if(subMenu){
							subMenu.classList.remove('open');
						}
					},200);
				});
				primary_nav.addEventListener("keydown", (event) => {
					if (event.key === 'Enter') {
						if (subMenu) {
							subMenu.classList.add('open');
						}
					}
				});
			});	
		}

		let secondaryNav = document.getElementById('secondary-header-ul_nav');
		if(secondaryNav){
			secondaryNav.querySelectorAll('li').forEach(function(secondary_nav) {
				secondary_nav.addEventListener("mouseover", (event) => {
					secondary_nav.classList.add('hover');
					if(secondary_nav.querySelector('ul.submenu')){
						secondary_nav.querySelector('ul.submenu').classList.add('open');
					}
				});
				secondary_nav.addEventListener("mouseout", (event) => {
					secondary_nav.classList.remove('hover');
					if(secondary_nav.querySelector('ul.submenu')){
						secondary_nav.querySelector('ul.submenu').classList.remove('open');
					}
				});
			});
		}

		/* Lightbox Gallerys */
		const customLightbox = new LBX('.js-lbx-gallery', {
			customClass:'lbx-gallery',
		});
		const quoteLightbox = new LBX('.js-lbx-quote-slider', {
			customClass:'lbx-quote-slider',
		});

		/* Gallerys Mobile delay style */
		if (window.innerWidth < 768) {
			setTimeout(() => {
				if (document.querySelector('#gallery-flex #start-content')) {
					document.querySelector('#gallery-flex #start-content').classList.add('loading');
				}
			}, 800);
			
		}
		

		// Attractions columns ----------------------------------------------------------
	

			let link_filter = document.querySelectorAll(".js-filter");
			let all_item = document.querySelectorAll(".js-column");
			let select_filter = document.getElementById("select_room");

			// Desktop Filter

			if (link_filter) {
				link_filter.forEach(link => {
					link.addEventListener('click', function(e) {
						e.preventDefault();

						link_filter.forEach(item => item.classList.remove("active"));
						this.classList.add("active");

						const filter_tag = this.dataset.filter;

						all_item.forEach(currentItem => {
							currentItem.classList.toggle("hidden", !currentItem.classList.contains(filter_tag));
						});
					});
				});
			}
			
			// Mobile Filter

			function filterItems(filter_tag) {
				all_item.forEach(currentItem => {
				currentItem.classList.toggle("hidden", !currentItem.classList.contains(filter_tag));
				});
			}
		
			if (link_filter) {
				link_filter.forEach(link => {
					link.addEventListener('click', function(e) {
					e.preventDefault();
			
					link_filter.forEach(item => item.classList.remove("active"));
					this.classList.add("active");
			
					const filter_tag = this.dataset.filter;
			
					filterItems(filter_tag);
					});
				});
			}
		
			if (select_filter) {
				select_filter.addEventListener('change', function() {
					const filter_tag = this.options[this.selectedIndex].dataset.filter;
					filterItems(filter_tag);
			});
		}

		// Remove BR label from amenities title on mobile devices
		let amenitiesTitle = document.querySelectorAll('.js-remove-br');
		if(amenitiesTitle){
				if (window.innerWidth < 640) {
						amenitiesTitle.forEach(element => {
						element.innerHTML = element.innerHTML.replace(/<br\s*\/?>/gi, '');
					});
				}
			}
		});

		window.onload = function () {
			scrollW();
			window.addEventListener('scroll', function () {
				scrollW();
			})
		};
	/* Remove empty <p> tags created by tinymce */
	const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

	//// Forms animation for labels   ----------------------------------------------------------------
	//Email signup animation
	if (document.getElementById('email-signup_email_address')) {
		document.getElementById('email-signup_email_address').addEventListener('focus', function () {
			this.parentElement.classList.add('moved');
		});
	}
	if (document.getElementById('email-signup_first_name')) {
		document.getElementById('email-signup_first_name').addEventListener('focus', function () {
			this.parentElement.classList.add('moved');
		});
	}
	if (document.getElementById('email-signup_last_name')) {
		document.getElementById('email-signup_last_name').addEventListener('focus', function () {
			this.parentElement.classList.add('moved');
		});
	}
	//CMS forms label animation ----------------------------------------------------------------
	// if (document.getElementsByClassName('form-module__field').length > 0) {
	// 	const MODULE_FIELDS = document.querySelectorAll('.form-module__field');
	// 	MODULE_FIELDS.forEach((field) => {
	// 		if (field.getElementsByTagName('input').length > 0) {
	// 			if (field.getElementsByTagName('input')[0].type.toLowerCase() != 'checkbox' && field.getElementsByTagName('input')[0].type.toLowerCase() != 'radio') {
	// 				field.getElementsByTagName('input')[0].addEventListener('focus', function () {
	// 					this.parentElement.classList.add('moved');
	// 				});
	// 			}
	// 		}
	// 		if (field.getElementsByTagName('select').length > 0) {
	// 			field.getElementsByTagName('select')[0].addEventListener('focus', function () {
	// 				this.parentElement.classList.add('moved');
	// 			});
	// 		}
	// 		if (field.getElementsByTagName('textarea').length > 0) {
	// 			field.getElementsByTagName('textarea')[0].addEventListener('focus', function () {
	// 				this.parentElement.classList.add('moved');
	// 			});
	// 		}
	// 	});
	// }

		// BURGER MENU NAVIGATION:

		// // BURGUER MENU TABLET ----------------------------------------------------------------

		const menuBtn = document.getElementById('menu-btn');
		const navigation = document.querySelector('.navigation');
		const closeMenuBtn = document.querySelector('.js-close-menu');
		if(menuBtn){
			menuBtn.addEventListener('click', function(event) {
				event.preventDefault();
				navigation.classList.add('open');
			});
		}
		if(closeMenuBtn){
			closeMenuBtn.addEventListener('click', function(event) {
				event.preventDefault();
				navigation.classList.remove('open');
			});
		}
	
		

	// BURGUER MENU MOBILE ----------------------------------------------------------------

	const burgerMenuBtn = document.querySelector("#js-burgerMenuBtn");
	const burgerMenuContainer = document.querySelector("#js-menuContainer")
	const closeMenu = document.querySelector(".js-burger-close");
	
	//Open Menu

	if(burgerMenuBtn){
		burgerMenuBtn.addEventListener('click', function (e) {
			e.preventDefault();
			burgerMenuContainer.classList.add("open");
			document.body.classList.add("no-scroll");
		});
	}
	
	if(closeMenu){
		closeMenu.addEventListener('click', () => {
			burgerMenuContainer.classList.remove("open");
			document.body.classList.remove("no-scroll");
		});
	}

		
		let linkstoscrollPrivacyPolicy = document.querySelectorAll('li a.scroll');

		if(linkstoscrollPrivacyPolicy){
			linkstoscrollPrivacyPolicy.forEach(anchor => {
				anchor.addEventListener('click', function(event) {
					event.preventDefault(); 
					console.log(anchor);
		
					const targetElement = document.querySelector(this.getAttribute('href'));
					const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY;
					const offsetPosition = targetPosition - 110;
							window.scrollTo({
						top: offsetPosition,
						behavior: 'smooth'
					});
				});
			});
		}

		// Remove br inside ADA STATEMENT 
		const adaStatementWrapper = document.querySelector('.ada-statement.text-modules-wrapper');

		if (adaStatementWrapper) {
		const paragraphs = adaStatementWrapper.querySelectorAll('p');

		if (paragraphs.length > 0) {
			const lastParagraph = paragraphs[paragraphs.length - 1];

			const firstBr = lastParagraph.querySelector('br');

			if (firstBr) {
				firstBr.remove();
			}
		}
	}

	// //ADA LABELS
	// document.querySelector(".footer #email-signup .signup-btn").setAttribute("aria-label", "Subscribe to our email database");
	// if(document.querySelector("#form_id-3608 .form-module__submit .btn")){
	// 	document.querySelector("#form_id-3608 .form-module__submit .btn").setAttribute("aria-label", "Submit contact information");
	// }

})();

function animateto(target){
	var gotoTarget = offset(document.getElementById(target)).top - 140;
	var from     = window.pageYOffset
	var to       = gotoTarget
	var duration = 1300;
	var start = new Date().getTime()

	/* Time Interval */
	var timer = setInterval(function() {
		var time = new Date().getTime() - start

		if(from <= to ){
			var y = easeInOutQuart(time, from, to - from, duration)
		} else {

			var y = easeInOutQuart(time, from, -(from - to), duration)
		}
		window.scrollTo(0, y)
		if (time >= duration) clearInterval(timer)

	}, 1000 / 60);

	window.scrollTo(0, from)

}
/* Ease Movement */
function easeInOutQuart(t, b, c, d) {
	if ((t /= d / 2) < 1) return c / 2 * t * t * t * t + b;
	return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
}
function offset(el) {
	var rect = el.getBoundingClientRect(),
		scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
		scrollTop = window.pageYOffset || document.documentElement.scrollTop;
	return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}
/* ScrollW */
function scrollW() {
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if (st > 80) {
		if (st > lastScrollTop) {
			// downscroll code
			if (!document.getElementById('header').classList.contains('down')) {
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if (!document.getElementById('header').classList.contains('up')) {
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if (document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')) {
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}
const countDown = function (elements) {

	for (const element of elements) {

		const date = element.dataset.date;
		let formats = element.dataset.formats;

		if (!date || !formats)
			return;
		
		formats = formats.split(',');
		const format = formats.map(format => `<div class="countdown-time"><span></span>${format}</div>`).join('');
		element.insertAdjacentHTML("beforeend", format);
	
		const countDownDate = new Date(date).getTime();
		
		const timer = () => {
			let now = new Date().getTime();
			let dateDiff = countDownDate - now;
	
			let time = {
				days: String(Math.floor(dateDiff / (1000 * 60 * 60 * 24))).padStart(2, '0'),
				hours: String(Math.floor((dateDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))).padStart(2, '0'),
				minutes: String(Math.floor((dateDiff % (1000 * 60 * 60)) / (1000 * 60))).padStart(2, '0'),
				seconds: String(Math.floor((dateDiff % (1000 * 60)) / 1000)).padStart(2, '0')
			}

			time = Object.values(time);

			for (let i = 0; i < formats.length; i++) {
				element.getElementsByTagName("div")[i].getElementsByTagName("span")[0].textContent = time[i];
			}
	
			if (dateDiff < 0)
				clearInterval(timerInterval);
		}
	
		timer();
	
		const timerInterval = setInterval(timer, 1000);
	}

	
}
document.getElementsByClassName("js-countdown") && countDown(document.getElementsByClassName("js-countdown"));

